import { RestClient } from '@libs/rest-client';
import type { CustomFieldBasicSettingRaw, CustomFieldLedgerSettingRaw } from '../models';

const CUSTOM_FILED_URL = '/custom-field';

async function fetchBasicSettings() {
  return RestClient.fa.get<CustomFieldBasicSettingRaw[]>(`${CUSTOM_FILED_URL}/basic-setting`);
}

async function registerBasicSettings(requestBody: CustomFieldBasicSettingRaw[]) {
  await RestClient.fa.put(`${CUSTOM_FILED_URL}/basic-setting`, requestBody);
}

async function fetchLedgerSettings() {
  return RestClient.fa.get<CustomFieldLedgerSettingRaw[]>(`${CUSTOM_FILED_URL}/ledger-setting`);
}

async function registerLedgerSettings(requestBody: CustomFieldLedgerSettingRaw[]) {
  await RestClient.fa.put(`${CUSTOM_FILED_URL}/ledger-setting`, requestBody);
}

export { fetchBasicSettings, registerBasicSettings, fetchLedgerSettings, registerLedgerSettings };
